import { TreatyDetailsFragment } from '../../graphql/generated';

export type TreatyLabelMap = Partial<Record<string, string>>;

/**
 * Map the treaties to a user-friendly label
 */
export const createTreatyLabelMap = (
  treaties: TreatyDetailsFragment[]
): TreatyLabelMap => {
  return treaties.reduce(
    (acc, treaty) => ({ ...acc, [treaty.cedant]: treaty.name }),
    {}
  );
};
